import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { RedirectComponent } from './components/redirect/redirect.component';
import { AuthguardredirectComponent, Role, RoleGuard } from '@cleverly/shared/api-authorization';
import { redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { VerifyLoginComponent } from './components/verify-login/verify-login.component';

const canActivateData = {
    authGuardPipe: (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        let returnUrlQueryParam = '';
        if (state.url && state.url.length > 0) {
            returnUrlQueryParam = `?returnUrl=${state.url}`;
        }
        return redirectUnauthorizedTo(`/login${returnUrlQueryParam}`);
    },
};

const routes: Routes = [
    { 
        path: 'signup',
        loadChildren: () => import('@cleverly/customer/signup').then((m) => m.SignupModule),
    },
    {
        matcher: (url) => {
            if (url.length && ['login', 'reset-password'].includes(url[0].path)) {
                return { consumed: [] };
            }

            return null;
        },
        loadChildren: () => import('@cleverly/customer/login').then((m) => m.LoginModule),
    },
    {
        path: 'verify-login',
        component: VerifyLoginComponent,
    },
    { path: 'auth-redirect', component: AuthguardredirectComponent },
    {
        path: 'polls',
        loadChildren: () => import('@cleverly/shared/feedback').then((m) => m.FeedbackModule),
    },
    {
        path: 'invitation/:code',
        loadComponent: () => import('./components/cohort-invitation/cohort-invitation.component').then((m) => m.CohortInvitationComponent),
        title: 'cleverly | Einladung',
    },
    {
        path: 'meeting',
        loadComponent: () => import('./components/jitsi-meeting/jitsi-meeting.component').then((m) => m.JitsiMeetingComponent),
        canActivate: [RoleGuard],
        data: { roles: [Role.Student, Role.Parent, Role.Pedagogue], ...canActivateData },
        title: $localize`:Title for Meeting Route:cleverly | Meeting`,
    },
    {
        path: 'tutor',
        loadChildren: () => import('@cleverly/tutor/tutor-root').then((m) => m.TutorRootModule),
        canLoad: [RoleGuard],
        data: { roles: [Role.Pedagogue], ...canActivateData },
    },
    {
        path: '',
        loadChildren: () => import('@cleverly/customer/customer-root').then((m) => m.CustomerRootModule),
        canLoad: [RoleGuard],
        canActivate: [RoleGuard],
        data: { roles: [Role.Student, Role.Parent], ...canActivateData },
    },
    {
        path: 'nutzer/einloggen',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
